const debug = false;

const AppConfig = {
  app_name: "Laddar Agent",
  business_name: "Laddar Africa",
  business_website: "https://laddar.africa",
  api_base_url: debug ? "http://127.0.0.1:8000/v1/" : "https://api.laddar.africa/v1/",
  api_media_url: debug ? "http://127.0.0.1:8000/media/" : "https://api.laddar.africa/media/",
  api_cors_url: debug ? "http://127.0.0.1:8000/media/" : "https://api.laddar.africa/v1/cors/",
  // api_base_url: "http://127.0.0.1:8000/v1/",
  // api_media_url: "http://127.0.0.1:8000/media/",
  auth_token: "_ldr_dsa_auth_token",
  app_version_store: "_ldr_dsa_version_",
  sidenav_active_menu_color: "info",
  newInbox: 0,
  profile_reqd: false,
  whatsapp_group_link: "https://chat.whatsapp.com/D0N2QxD3r73LwscjgvlGlO",
  telegram_group_link: "https://t.me/+ET8DgPWxlEw4ZGE0",
  vapid_public_key:
    "BCME7eDe1yS3IbQUl_Pk2t6xj7Ft8cxe9OMUcdTfvSrldb80BkHUGLqBTsxyROk9-QwYWdQYTbbGvHsrAIjDt2w",
  google_map_key: "AIzaSyCmiv_wy1kjzBT6tcvMK56pdhfpG32Ljw0",
};

export default AppConfig;
